import { type Meta } from '../types/docs';

export const CREATED_WORKSPACE_LOCATIONS = ['in-app', 'onboarding', 'agent_onboarding'] as const;

export type CreatedWorkspaceLocation = (typeof CREATED_WORKSPACE_LOCATIONS)[number];

const META: Meta = {
  description: 'Event sent when a workspace is created',
  name: 'Created a workspace',
  params: [
    {
      description: 'Where the workspace was created',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...CREATED_WORKSPACE_LOCATIONS],
    },
  ],
};

export default META;
